<template>
    <div class="items-to-pull glass-theme">
        <!-- API Loading Overlay with Animation -->
        <transition name="loading-overlay">
            <div v-if="apiLoading" class="loading-overlay">
                <div class="loading-card">
                    <div class="loading-animation">
                        <div class="loading-ring">
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="loading-logo">
                                <i class="fas fa-boxes"></i>
                            </div>
                        </div>
                    </div>
                    <div class="loading-text">
                        <h3>{{ loadingMessage }}</h3>
                        <div class="loading-dots">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                    </div>
                    <div class="loading-progress">
                        <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                    </div>
                    <div class="loading-tips">
                        <p class="tip-text">{{ currentTip }}</p>
                    </div>
                </div>
            </div>
        </transition>

        <div>
            <div>
                <b-modal id="modal-itp-comments" scrollable size="md" hide-footer
                    :title="'COMMENTS FOR (' + item_comments_invoice_id + ')'">
                    <ItemComments
                        :viewdata="{ invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username }" />
                </b-modal>

                <div style="width: 100%;">
                    <div>
                        <b-alert variant="secondary" show class="glass-alert">
                            <div style="display: block;">
                                <!-- Date Range Picker -->
                                <div style="display: inline-block; vertical-align: top;">
                                    <div class="filter-label">SELECT DATE RANGE</div>
                                    <b-input
                                        id="dates"
                                        size="lg"
                                        variant="dark"
                                        :placeholder="query ? [query.startDate, query.endDate].join(' - ') : ''"
                                        style="display: inline-block; width: 220px; font-size: 14px; font-weight: bold;"
                                        class="responsive-input glass-input"
                                        autocomplete="off"
                                    ></b-input>
                                    <b-button size="sm" variant="dark" @click="search_dates" class="mt-1 mt-md-0 glass-btn">SEARCH</b-button>
                                </div>

                                <div style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                                    <div class="filter-label">SELECT STATUS</div>
                                    <b-form-select size="lg"
                                        :options="filteredStates"
                                        v-model="selected_state"
                                        class="glass-select"
                                        style="width: 180px; font-size: 17px; font-weight: bold;">
                                    </b-form-select>
                                </div>

                                <div style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                                    <div class="filter-label">PICK LOCATION</div>
                                    <b-form-select size="lg"
                                        :options="filteredPickLocations"
                                        v-model="pick_location_id"
                                        class="glass-select"
                                        style="width: 250px; font-size: 17px; font-weight: bold;">
                                    </b-form-select>
                                </div>

                                <div style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                                    <div class="filter-label">DROP LOCATION</div>
                                    <b-form-select size="lg"
                                        :options="filteredDropLocations"
                                        v-model="drop_location_id"
                                        class="glass-select"
                                        style="width: 250px; font-size: 17px; font-weight: bold;">
                                    </b-form-select>
                                </div>
                                <div style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                                    <div class="filter-label">ORDER TYPE</div>
                                    <b-form-select size="lg"
                                        :options="filteredOrderTypes"
                                        v-model="selected_order_type"
                                        class="glass-select"
                                        style="width: 200px; font-size: 17px; font-weight: bold;">
                                    </b-form-select>
                                </div>
                            </div>
                        </b-alert>
                    </div>
                </div>

                <div style="width: 100%; padding: 5px; min-height: 0px;">
                    <b-card no-body class="glass-table-card" style="min-height: 0px;">
                        <!-- Bulk Action Bar - NEW -->
                        <div v-if="selectedItems.length > 0" class="bulk-action-bar glass-card">
                            <div class="bulk-action-content">
                                <span class="selected-count">{{ selectedItems.length }} item(s) selected</span>
                                <div class="bulk-actions">
                                    <b-form-select
                                        v-model="bulkActionState"
                                        class="bulk-state-select glass-select"
                                        :options="getBulkStateOptions()"
                                        style="width: 200px; font-size: 14px; font-weight: bold;"
                                    >
                                        <template #first>
                                            <b-form-select-option :value="null">Change Status to...</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <b-button
                                        variant="primary"
                                        @click="applyBulkStateUpdate"
                                        :disabled="!bulkActionState || isBulkUpdating"
                                        class="apply-bulk-btn glass-btn"
                                    >
                                        {{ isBulkUpdating ? 'Updating...' : 'Apply to Selected' }}
                                    </b-button>
                                    <b-button
                                        variant="outline-secondary"
                                        @click="clearSelection"
                                        class="clear-selection-btn"
                                        :disabled="isBulkUpdating"
                                    >
                                        Clear Selection
                                    </b-button>
                                </div>
                            </div>
                        </div>

                        <div v-if="items_being_loaded == true">
                            <loading :active="true" :can-cancel="false" :is-full-page="false">
                            </loading>
                        </div>

                        <div v-else-if="items_being_loaded == false">
                            <div v-if="items.length > 0" class="diver">
                                <table style="width: 100%; overflow-x: scroll;" class="glass-table">
                                    <thead>
                                        <tr style="font-size: 14px; text-align: center;">
                                            <!-- NEW: Checkbox column -->
                                            <td class="srr glass-table-header" style="width: 40px;">
                                                <b-form-checkbox
                                                    v-model="selectAll"
                                                    @change="toggleSelectAll"
                                                    class="select-all-checkbox"
                                                    :disabled="isBulkUpdating"
                                                ></b-form-checkbox>
                                            </td>
                                            <td class="srr glass-table-header" @click="sortby('invoice_id')" style="width: 100px;">
                                                INVOICE #
                                            </td>

                                            <td class="srr glass-table-header" style="width:70px;" @click="sortby('product_sku')">
                                                PRODUCT SKU
                                            </td>

                                            <td class="srr glass-table-header" style="width:200px;" @click="sortby('product_name')">
                                                PRODUCT NAME
                                            </td>

                                            <td class="srr glass-table-header" @click="sortby('is_special')" style="width:70px;">
                                                PRD TYPE
                                            </td>

                                            <td class="srr glass-table-header" @click="sortby('order_type')" style="width:100px;">
                                                ORDER TYPE
                                            </td>

                                            <td class="srr glass-table-header" style="width:50px;">
                                                QTY
                                            </td>

                                            <td class="srr glass-table-header" @click="sortby('original_locsub')" style="width: 150px;">
                                                ITEM PICK FROM
                                            </td>
                                            <td class="srr glass-table-header" @click="sortby('drop_locsub')" style="width: 200px;">
                                               DROP LOCATION
                                             </td>
                                            <td class="srr glass-table-header" style="width: 200px;">
                                                DELIVERY LOC
                                            </td>
                                            <td class="srr glass-table-header" @click="sortby('pickup_truck', packet && packet.trucksdict)"
                                                style="width:70px;">
                                                PICKUP TRUCK
                                            </td>

                                            <td class="srr glass-table-header" style="width: 120px;" @click="sortby('state')">
                                                STATUS
                                            </td>

                                            <td class="hidden-print srr glass-table-header" style="width:70px;">
                                                COMMENTS
                                            </td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr style="background: white; font-size: 14px; text-align: center;"
                                            v-for="item, idx in filteredItems" v-bind:key="idx" class="glass-table-row">
                                            <!-- NEW: Checkbox cell -->
                                            <td class="srrv">
                                                <b-form-checkbox
                                                    v-model="selectedItems"
                                                    :value="getItemIdentifier(item)"
                                                    @change="updateSelectAll"
                                                    class="item-checkbox"
                                                    :disabled="isBulkUpdating || should_disable_checkbox(item)"
                                                ></b-form-checkbox>
                                            </td>
                                            <td class="srrv">
                                                {{ item.invoice_id }}
                                            </td>

                                            <td class="srrv">
                                                {{ (item.product_sku || '').toUpperCase() }}
                                            </td>

                                            <td class="srrv">
                                                {{ (item.product_name || '').toUpperCase() }}
                                            </td>

                                            <td class="srrv">
                                                <div v-if="item.is_special" style="background: pink; padding: 3px;">SPECIAL
                                                </div>
                                                <div v-else>REGULAR</div>
                                            </td>

                                            <td class="srrv">
                                                <div v-if="item.order_type == 'home_delivery'">
                                                    <b-alert show variant="primary" style="padding: 2px; font-size: 11px; text-align: center;">HOME DELIVERY </b-alert>
                                                </div>
                                                <div v-else-if="item.order_type == 'store_pickup'">
                                                    <b-alert show variant="warning" style="padding: 2px; font-size: 11px; text-align: center;">STORE PICKUP</b-alert>
                                                </div>
                                                <div v-else-if="item.order_type == 'transfer_order'">
                                                    <b-alert show variant="info" style="padding: 2px; font-size: 11px; text-align: center;">STORE TRANFER</b-alert>
                                                </div>
                                                <div v-else>
                                                    {{item.order_type}}
                                                </div>
                                            </td>

                                            <td class="srrv">
                                                {{ item.quantity }}
                                            </td>

                                            <td class="srrv">
                                                {{ packet && packet.locsubsdict ? (packet.locsubsdict[item.original_locsub ? item.original_locsub : item.original_locsub] || '') : '' }}
                                            </td>

                                            <td class="srrv">
                                                {{ packet && packet.locsubsdict ? (packet.locsubsdict[item.ship_locsub ? item.ship_locsub : item.ship_locsub] || '') : '' }}
                                            </td>

                                            <td class="srrv">
                                                {{ packet && packet.locsubsdict ? (packet.locsubsdict[item.drop_locsub ? item.drop_locsub : item.drop_locsub] || '') : '' }}
                                            </td>

                                            <td class="srrv">
                                                {{ packet && packet.trucksdict ? (packet.trucksdict[item.pickup_truck] || '') : '' }}
                                            </td>

                                            <td class="srrv" style="width:150px;">
                                                <b-form-select size="sm"
                                                    :style="{ background: get_background(item) }"
                                                    :options="check_states(item)" v-model="item.state"
                                                    v-on:change="update_invoice_item_state(item)"
                                                    :disabled="should_disable_dropdown(item) || isBulkUpdating"
                                                    v-b-tooltip.hover="get_tooltip_message(item)"
                                                    class="glass-status-select">
                                                </b-form-select>
                                            </td>

                                            <td class="ipt_tdr srrv hidden-print">
                                                <button class="glass-comment-btn" @click="show_comments(item)" :disabled="isBulkUpdating">CMNT</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div v-else>
                                <b-alert show class="glass-empty-alert">NO ITEM FOUND</b-alert>
                            </div>
                        </div>

                        <div v-else>
                        </div>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import mappings from '@/utilities/mappings'
import Requestor from '@/utilities/Requestor';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ItemComments from '@/components/importables/ItemComments'

export default {
    name: "ItemsToPull",
    components: { Loading, ItemComments },
    data: function () {
        let out = {
            items: [],
            dates: [],
            active_date: null,
            packet: null,
            items_being_loaded: null,
            dates_being_loaded: null,
            current_date: null,
            locations: [],
            locsub: null,
            original_locsub: null,
            states: [],
            states_dict: mappings.states_dict,
            item_comments_invoice_id: null,
            item_comments_itemid: null,
            colors_dict: {},
            allowed_truck: null,
            allowed_locsub: null,
            locsubs: [],
            original_locsubs: [],
            
            query: {
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD')
            },
            
            selected_order_type: null,
            pick_location_id: null,
            drop_location_id: null,
            selected_state: null,
            
            // Loading animation properties
            apiLoading: false,
            loadingMessage: 'Loading Items',
            loadingProgress: 0,
            currentTipIndex: 0,
            loadingInterval: null,
            tipInterval: null,
            msgInterval: null,
            apiCallStack: 0,
            isUpdating: false,
            
            // Multi-select properties - NEW
            selectedItems: [],
            selectAll: false,
            bulkActionState: null,
            isBulkUpdating: false,
            bulkUpdateComplete: false,
            
            tips: [
                "📦 Fetching items to pull...",
                "🚚 Loading delivery schedules...",
                "📍 Syncing location data...",
                "📊 Processing inventory...",
                "🔄 Updating pull lists...",
                "✨ Organizing items...",
                "📈 Preparing data..."
            ]
        }

        return out
    },
    computed: {
        filteredItems() {
            if (!this.packet) {
                return [];
            }
            
            const filtered = this.items.filter(item => {
                const allowed = this.is_allowed(item);
                const hasQuantity = item.quantity > 0;
                const stateFiltered = this.filter_state(item);
                const pulledState = this.is_pulled_state(item);
                const orderTypeFiltered = this.filter_order_type(item);

                return allowed && hasQuantity && stateFiltered && pulledState && orderTypeFiltered;
            });

            return filtered;
        },

        filteredStates() {
            if (!this.packet || this.items.length === 0) return [];

            const preFilteredItems = this.items.filter(item =>
                this.is_allowed(item) &&
                item.quantity > 0 &&
                this.is_pulled_state(item)
            );

            const uniqueStates = [...new Set(preFilteredItems.map(item => item.state))];

            const stateOptions = [
                { value: null, text: 'ALL STATES' }
            ];

            uniqueStates.forEach(stateValue => {
                const stateText = this.states_dict[stateValue];
                if (stateText) {
                    stateOptions.push({
                        value: stateValue,
                        text: stateText
                    });
                }
            });

            return stateOptions;
        },

        filteredPickLocations() {
            if (!this.packet || !this.packet.locsubs || this.filteredItems.length === 0) return [];

            const uniqueLocsubs = [...new Set(this.filteredItems.map(item =>
                item.original_locsub || item.locsub
            ).filter(locsub => locsub !== null))];

            const locationOptions = [
                { value: null, text: 'ALL PICK LOCATIONS' }
            ];

            const availableLocsubs = this.packet.locsubs.filter(locsub =>
                uniqueLocsubs.includes(locsub.value)
            );

            const displayOptions = availableLocsubs.map(locsub => ({
                value: locsub.value,
                text: this.packet.locsubsdict[locsub.value] || locsub.value
            }));

            displayOptions.sort((a, b) => a.text.localeCompare(b.text));

            return locationOptions.concat(displayOptions);
        },

        filteredDropLocations() {
            if (!this.packet || !this.packet.locsubs || this.filteredItems.length === 0) return [];

            const uniqueLocsubs = [...new Set(this.filteredItems.map(item =>
                item.drop_locsub
            ).filter(locsub => locsub !== null))];

            const locationOptions = [
                { value: null, text: 'ALL DROP LOCATIONS' }
            ];

            const availableLocsubs = this.packet.locsubs.filter(locsub =>
                uniqueLocsubs.includes(locsub.value)
            );

            const displayOptions = availableLocsubs.map(locsub => ({
                value: locsub.value,
                text: this.packet.locsubsdict[locsub.value] || locsub.value
            }));

            displayOptions.sort((a, b) => a.text.localeCompare(b.text));

            return locationOptions.concat(displayOptions);
        },

        filteredOrderTypes() {
            if (!this.packet || this.filteredItems.length === 0) return [];

            const uniqueOrderTypes = [...new Set(this.filteredItems.map(item => item.order_type))];

            const orderTypeOptions = [
                { value: null, text: 'ALL ORDER TYPES' }
            ];

            uniqueOrderTypes.forEach(orderType => {
                let displayText = '';
                switch(orderType) {
                    case 'home_delivery':
                        displayText = 'HOME DELIVERY';
                        break;
                    case 'store_pickup':
                        displayText = 'STORE PICKUP';
                        break;
                    case 'transfer_order':
                        displayText = 'STORE TRANSFER';
                        break;
                    default:
                        displayText = orderType ? orderType.toUpperCase().replace(/_/g, ' ') : 'UNKNOWN';
                }

                if (orderType) {
                    orderTypeOptions.push({
                        value: orderType,
                        text: displayText
                    });
                }
            });

            return orderTypeOptions;
        }
    },
    methods: {
        // ========== MULTI-SELECT METHODS ==========
        getItemIdentifier: function(item) {
            return `${item.invoice_id}|${item.itemid}`;
        },

        toggleSelectAll: function() {
            if (this.selectAll) {
                const allIds = this.filteredItems.map(item => this.getItemIdentifier(item));
                this.selectedItems = allIds;
            } else {
                this.selectedItems = [];
            }
        },

        updateSelectAll: function() {
            const filteredIds = this.filteredItems.map(item => this.getItemIdentifier(item));
            if (filteredIds.length === 0) {
                this.selectAll = false;
                return;
            }
            this.selectAll = filteredIds.every(id => this.selectedItems.includes(id));
        },

        clearSelection: function() {
            this.selectedItems = [];
            this.selectAll = false;
            this.bulkActionState = null;
        },

        should_disable_checkbox: function(item) {
            // Disable checkbox for items that can't be updated
            return this.should_disable_dropdown(item) || item.state === 30;
        },

        getBulkStateOptions: function() {
            return this.get_allowed_states().filter(state => {
                // Don't show current state or invalid states for bulk update
                return state.value !== 0 && state.value !== null && !state.disabled;
            });
        },

        getSelectedItemsData: function() {
            return this.filteredItems.filter(item => {
                const identifier = this.getItemIdentifier(item);
                return this.selectedItems.includes(identifier);
            });
        },

        applyBulkStateUpdate: function() {
            if (!this.bulkActionState || this.isBulkUpdating) return;

            const selectedItems = this.getSelectedItemsData();
            if (selectedItems.length === 0) {
                this.$bvToast.toast(
                    "No items selected for bulk update.",
                    {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                );
                return;
            }

            this.$bvModal.msgBoxConfirm(
                `Are you sure you want to update ${selectedItems.length} item(s) to status: ${this.getStatusText(this.bulkActionState)}?`,
                {
                    title: 'Confirm Bulk Update',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            ).then(value => {
                if (value) {
                    this.processBulkStateUpdate(selectedItems);
                }
            }).catch(err => {
                // Handle cancellation
            });
        },

        getStatusText: function(statusValue) {
            const option = this.get_allowed_states().find(s => s.value === statusValue);
            return option ? option.text : `Status ${statusValue}`;
        },

        processBulkStateUpdate: function(selectedItems) {
            this.isBulkUpdating = true;
            this.bulkUpdateComplete = false;
            this.startApiLoading(`Updating ${selectedItems.length} items`);

            const that = this;
            let completed = 0;
            let successful = 0;
            let failed = 0;
            let errors = [];

            const batchSize = 5;
            const batches = this.chunkArray(selectedItems, batchSize);

            let batchPromises = batches.map((batch, batchIndex) => {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        this.processBulkBatch(batch, (batchSuccess, batchErrors) => {
                            successful += batchSuccess;
                            failed += batchErrors.length;
                            errors = errors.concat(batchErrors);
                            completed += batch.length;
                            
                            const progress = Math.min(Math.round((completed / selectedItems.length) * 90), 90);
                            that.loadingProgress = progress;
                            that.loadingMessage = `Updating ${completed}/${selectedItems.length} items...`;
                            
                            resolve();
                        });
                    }, batchIndex * 300);
                });
            });

            Promise.all(batchPromises).then(() => {
                that.loadingProgress = 100;
                that.loadingMessage = 'Finalizing...';
                
                setTimeout(() => {
                    that.stopApiLoading(true);
                    that.isBulkUpdating = false;
                    that.bulkUpdateComplete = true;
                    that.clearSelection();

                    let message = `Bulk update completed: ${successful} successful`;
                    if (failed > 0) {
                        message += `, ${failed} failed`;
                    }
                    that.$bvToast.toast(
                        message,
                        {
                            title: failed > 0 ? "Partial Success" : "Success",
                            autoHideDelay: 3000,
                            variant: failed > 0 ? "warning" : "success"
                        }
                    );

                    if (errors.length > 0) {
                        console.error('Bulk update errors:', errors);
                        const errorMessage = errors.slice(0, 3).join('\n');
                        if (errors.length > 3) {
                            that.$bvToast.toast(
                                `${errorMessage}\n... and ${errors.length - 3} more errors`,
                                {title: "Errors", autoHideDelay: 5000, variant:"danger"}
                            );
                        } else {
                            that.$bvToast.toast(
                                errorMessage,
                                {title: "Errors", autoHideDelay: 5000, variant:"danger"}
                            );
                        }
                    }
                }, 500);
            }).catch(error => {
                console.error('Bulk update error:', error);
                that.stopApiLoading(false);
                that.isBulkUpdating = false;
                that.$bvToast.toast(
                    "An unexpected error occurred during bulk update.",
                    {title: "Error", autoHideDelay: 3000, variant:"danger"}
                );
            });
        },

        processBulkBatch: function(batch, callback) {
            let successful = 0;
            let errors = [];
            let completed = 0;
            const that = this;

            batch.forEach((item, index) => {
                const originalState = item.state;
                that.$set(item, 'state', that.bulkActionState);

                let incomingType = this.determineIncomingType(item);

                let data = {
                    invoice_id: item.invoice_id,
                    itemid: item.itemid,
                    state: that.bulkActionState,
                    changed_by: that.packet.userDetails.username,
                    product_sku: item.product_sku,
                    quantity: item.quantity,
                    incoming_type: incomingType,
                    pickup_truck: item.pickup_truck,
                    bulk_update: true
                };

                setTimeout(() => {
                    Requestor.postAsync(
                        "/api/sales/update_invoice_item_state/",
                        data,
                        function(response) {
                            if (response.data.error) {
                                that.$set(item, 'state', originalState);
                                errors.push(`Item ${item.invoice_id}: ${response.data.error}`);
                            } else {
                                successful++;
                                if (response.data.result) {
                                    const updatedData = response.data.result;
                                    const index = that.items.findIndex(i => 
                                        i.invoice_id === item.invoice_id && i.itemid === item.itemid
                                    );
                                    if (index !== -1) {
                                        that.$set(that.items, index, {...that.items[index], ...updatedData});
                                    }
                                }
                            }
                            completed++;
                            if (completed === batch.length) {
                                callback(successful, errors);
                            }
                        },
                        function(error) {
                            that.$set(item, 'state', originalState);
                            errors.push(`Item ${item.invoice_id}: Network error`);
                            completed++;
                            if (completed === batch.length) {
                                callback(successful, errors);
                            }
                        }
                    );
                }, index * 150);
            });
        },

        chunkArray: function(array, size) {
            const chunks = [];
            for (let i = 0; i < array.length; i += size) {
                chunks.push(array.slice(i, i + size));
            }
            return chunks;
        },

        determineIncomingType: function(item) {
            let incomingType = '';
            if (item.incoming_type) {
                incomingType = item.incoming_type.toUpperCase();
            } else if (item.order_type) {
                let orderType = item.order_type.toUpperCase();
                if (orderType.includes('TRANSFER')) {
                    incomingType = 'STORE_TRANSFER_ORDER';
                } else if (orderType.includes('DAMAGE')) {
                    incomingType = 'DAMAGE_ORDER';
                } else if (orderType.includes('HOME_DELIVERY') || orderType.includes('STORE_PICKUP')) {
                    incomingType = 'REGULAR_ORDER';
                }
            }
            if (!incomingType && item.invoice_id) {
                if (item.invoice_id.toString().includes('TRANSFER') || 
                    item.invoice_id.toString().includes('TO')) {
                    incomingType = 'STORE_TRANSFER_ORDER';
                } else if (item.invoice_id.toString().includes('DAMAGE') || 
                        item.invoice_id.toString().includes('DO')) {
                    incomingType = 'DAMAGE_ORDER';
                }
            }
            if (!incomingType) {
                incomingType = 'REGULAR_ORDER';
            }
            return incomingType;
        },

        // ========== LOADING METHODS ==========
        startApiLoading(message = 'Loading Items') {
            this.stopApiLoading(true);
            this.apiCallStack = 1;
            this.apiLoading = true;
            this.loadingMessage = message;
            this.loadingProgress = 0;
            this.currentTipIndex = 0;
            
            if (this.loadingInterval) clearInterval(this.loadingInterval);
            if (this.tipInterval) clearInterval(this.tipInterval);
            if (this.msgInterval) clearInterval(this.msgInterval);
            
            this.loadingInterval = setInterval(() => {
                if (this.loadingProgress < 90) {
                    this.loadingProgress += Math.random() * 8;
                    if (this.loadingProgress > 90) this.loadingProgress = 90;
                }
            }, 300);
            
            this.tipInterval = setInterval(() => {
                if (this.currentTipIndex < this.tips.length - 1) {
                    this.currentTipIndex++;
                } else {
                    this.currentTipIndex = 0;
                }
            }, 2500);
            
            let messages = ['Loading Items', 'Fetching Data', 'Processing Records', 'Updating List', 'Finalizing'];
            let msgIndex = 0;
            this.msgInterval = setInterval(() => {
                if (msgIndex < messages.length - 1) {
                    msgIndex++;
                    this.loadingMessage = messages[msgIndex];
                }
            }, 2000);
        },
        
        stopApiLoading(success = true) {
            if (this.loadingInterval) {
                clearInterval(this.loadingInterval);
                this.loadingInterval = null;
            }
            if (this.tipInterval) {
                clearInterval(this.tipInterval);
                this.tipInterval = null;
            }
            if (this.msgInterval) {
                clearInterval(this.msgInterval);
                this.msgInterval = null;
            }
            
            this.apiCallStack = 0;
            
            if (success) {
                this.loadingProgress = 100;
                this.loadingMessage = 'Complete!';
                setTimeout(() => {
                    this.apiLoading = false;
                    this.loadingProgress = 0;
                }, 400);
            } else {
                this.apiLoading = false;
                this.loadingProgress = 0;
            }
        },

        // ========== FILTER METHODS ==========
        filter_order_type: function(item) {
            let status = true;
            if (this.selected_order_type) {
                if (item.order_type !== this.selected_order_type) {
                    status = false;
                }
            }
            return status;
        },
        
        is_pulled_state: function(item) {
            return [0, 2,-2, 14 ,15, 3, -3, 30, -30].includes(item.state);
        },
        
        is_allowed: function(row) {
            if (!this.packet || !this.packet.userDetails) {
                return false;
            }
            
            let userrole = this.packet.userDetails.userrole;

            if (userrole !== "admin" && userrole !== "officeuser") {
                if (![0, 2, -2, 14, 15, 3, -3, 30, -30].includes(row.state)) {
                    return false;
                }
            }

            let status = true;
            if (this.grn_al(row, 'pick_location_id') == false || this.grn_al(row, 'drop_location_id') == false) {
                status = false;
            }
            return status
        },
        
        filter_state: function (item) {
            let status = true;
            if (this.selected_state !== null) {
                const selectedState = Number(this.selected_state);
                const itemState = Number(item.state);

                if (itemState !== selectedState) {
                    status = false;
                }
            }
            return status
        },
        
        grn_al: function (row, item) {
            let out = true;

            if (row.state === 30) {
                return true;
            }

            if (item == 'pick_location_id') {
                if (this.pick_location_id) {
                    const hasMatchingLocation =
                        (row.locsub && row.locsub == this.pick_location_id) ||
                        (row.original_locsub && row.original_locsub == this.pick_location_id) ||
                        (row.pull_location_id && row.pull_location_id == this.pick_location_id);

                    if (!hasMatchingLocation) {
                        out = false;
                    }
                }
            }

            if (item == 'drop_location_id') {
                if (this.drop_location_id) {
                    if (row.drop_locsub && row.drop_locsub != this.drop_location_id) {
                        out = false;
                    }
                    if (row.ship_locsub && row.ship_locsub != this.drop_location_id) {
                        out = false;
                    }
                }
            }

            return out;
        },
        
        get_allowed_states: function() {
            if (!this.packet || !this.packet.userDetails) {
                return mappings.states.map(function(d){ d.disabled = true; return d; });
            }
            
            let userrole = this.packet.userDetails.userrole;

            if (userrole === "admin") {
                return mappings.states.map(function(d){ 
                    d.disabled = false; 
                    return d; 
                });
            } else {
                let allowedStates = mappings.states.filter(function(d){
                    return [0, 2, -2, 14, 15, 3, -3, 30, -30].includes(d.value);
                });

                if (userrole == "warehouseuser" || userrole == "warehousemanager" || userrole == "deliverytruck" || userrole == "housetruck") {
                    return allowedStates.map(function(d){ d.disabled = false; return d; });
                }
                else {
                    return allowedStates.map(function(d){ d.disabled = true; return d; });
                }
            }
        },
        
        check_states: function(item) {
            if (!this.packet || !this.packet.userDetails) {
                return [{ value: item.state, text: 'Loading...', disabled: true }];
            }
            
            let userrole = this.packet.userDetails.userrole;
            let that = this;

            if (this.is_ali_truck(item)) {
                return [{ value: item.state, text: 'ASSIGN TRUCK FIRST', disabled: true }];
            }

            const allStates = mappings.states.map(state => ({
                value: state.value,
                text: state.text,
                disabled: true
            }));

            const getSelectableStates = () => {
                if (userrole === "admin") {
                    return allStates.map(state => state.value);
                }
                
                let selectable = [];
                
                if ([3, -3, 15 ,30, -30].includes(item.state)) {
                    selectable = [0, 2, -2, 14 , 15, 3, -3, 30, -30];
                }
                else if (item.state === 2) {
                    selectable = [2, 14, 15,3, -3, 30, -30];
                }
                else if (item.state === -2) {
                    selectable = [-2, 14, 15, 3, -3, 30, -30];
                }
                else if (item.state === 14) {
                    selectable = [14, 15, 3, -3, 30, -30];
                }
                else if (item.state === 15) {
                    selectable = [14, 14, 3, -3, 30, -30];
                }
                else if (item.state === 0) {
                    if (userrole == "locationadmin" && item.pull_location_id == that.packet.userDetails.properties.location_id) {
                        selectable = [0, 2, -2, 14, 15, 3, -3, 30, -30];
                    } else {
                        selectable = [0, 2, -2, 14, 15, 3, -3, 30, -30];
                    }
                }
                else {
                    selectable = [item.state];
                }
                
                return selectable;
            };

            const selectableStates = getSelectableStates();
            
            return allStates.map(state => {
                const isSelectable = selectableStates.includes(state.value);
                const isCurrentState = state.value === item.state;
                
                if (isCurrentState) {
                    return {
                        ...state,
                        disabled: false,
                        text: state.text
                    };
                }
                
                return {
                    ...state,
                    disabled: !isSelectable,
                    text: isSelectable ? state.text : `${state.text}`
                };
            });
        },
        
        should_disable_dropdown: function(item) {
            if (!this.packet || !this.packet.userDetails || !this.packet.locsubsdict) {
                return true;
            }
            
            let userrole = this.packet.userDetails.userrole;
            let isAdmin = userrole === "admin";
            
            if (isAdmin) {
                return this.packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK'  
                || this.is_ali_truck(item);
            }
            else {
                return this.packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK' ||
                       item.state == 30 || item.state == 0
                       || this.is_ali_truck(item);
            }
        },
        
        is_ali_truck: function(item) {
            return !item.pickup_truck;
        },
        
        get_tooltip_message: function(item) {
            if (this.is_ali_truck(item)) {
                return 'Item needs to be assigned a truck';
            }
            return '';
        },
        
        get_background: function(item) {
            let state = item.state;
            let bg = 'white'

            if (this.is_ali_truck(item)) {
                bg = 'lightcoral';
            }
            else if (state == 0 || state == 2 || state == -2) {
                bg = 'lightyellow';
            }
            else if (state == 3) {
                bg = 'lightgreen';
            }
            else if (state == -3) {
                bg = 'red';
            }
            else if (state == 30) {
                bg = 'lightblue';
            }
            else {
                bg = 'lightgray';
            }
            return bg
        },
        
        allowed: function (item) {
            let status = true;
            if (this.pick_location_id == null) {
                status = true;
            }
            else {
                if (this.pick_location_id == item.pull_location_id) {
                    status = true
                }
                else {
                    status = false;
                }
            }
            return status
        },
        
        toggle_details: function (item) {
            item.show_details = (!item.show_details)
        },
        
        show_comments: function (item) {
            this.item_comments_invoice_id = item.invoice_id;
            this.item_comments_itemid = item.itemid;
            this.$bvModal.show("modal-itp-comments");
        },
        
        // ========== UPDATE METHODS ==========
        update_invoice_item_state: function (item) {
            if (!this.packet || !this.packet.userDetails) {
                this.$bvToast.toast(
                    "User data not loaded yet.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
                return;
            }
            
            if (this.isUpdating) {
                return;
            }
            this.isUpdating = true;
            
            let path = "/api/sales/update_invoice_item_state/"
            let that = this;

            const originalState = item.state;

            let incomingType = this.determineIncomingType(item);

            let data = {
                invoice_id: item.invoice_id,
                itemid: item.itemid,
                state: item.state,
                changed_by: this.packet.userDetails.username,
                product_sku: item.product_sku,
                quantity: item.quantity,
                pick_location: item.original_locsub || item.locsub,
                ship_location: item.ship_locsub || item.drop_locsub,
                drop_location: item.drop_locsub,
                original_locsub: item.original_locsub,
                ship_locsub: item.ship_locsub,
                incoming_type: incomingType,
                pickup_truck: item.pickup_truck
            }

            let s = function (response) {
                that.isUpdating = false;
                
                if (response.data.error) {
                    that.$bvToast.toast(
                        response.data.error,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                    that.$set(item, 'state', originalState);
                }
                else {
                    that.$bvToast.toast(
                        "Success updating item state.",
                        { title: "Success", autoHideDelay: 1500, variant: "success" }
                    );
                    
                    if (response.data.result) {
                        const updatedData = response.data.result;
                        const index = that.items.findIndex(i => 
                            i.invoice_id === item.invoice_id && i.itemid === item.itemid
                        );
                        if (index !== -1) {
                            that.$set(that.items, index, {...that.items[index], ...updatedData});
                        }
                    }
                }
            }

            let f = function (error) {
                that.isUpdating = false;
                that.$bvToast.toast(
                    "Error updating item state.",
                    { title: "Error", autoHideDelay: 1500, variant: "danger" }
                );
                that.$set(item, 'state', originalState);
            }

            Requestor.postAsync(path, data, s, f);
        },
        
        search_dates: function(e) {
            if (e) {
                e.preventDefault();
            }

            if (!this.query.startDate || !this.query.endDate) {
                this.$bvToast.toast(
                    "Please select a date range.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
                return;
            }

            this.get_pick_items_for_date_range();
        },
        
        get_pick_items_for_date_range: function () {
            let path = "/api/sales/get_pick_items_for_date_range/"
            let that = this;
            this.startApiLoading('Fetching Items');
            this.clearSelection();
            
            let data = { 
                startDate: this.query.startDate, 
                endDate: this.query.endDate, 
                merchandise_status: [1] 
            };

            if (this.packet && this.packet.userDetails) {
                let userrole = this.packet.userDetails.userrole;
                if (userrole !== 'admin' && userrole !== 'officeuser' && userrole !== 'housetruck') {
                    if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                        data.location_id = this.packet.userDetails.properties.location_id;
                    }
                }
            }

            let s = function (response) {
                if (response.data.result) {
                    that.items = response.data.result;
                }
                else {
                    that.$bvToast.toast(
                        response.data.error || "No items found",
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                }
                that.items_being_loaded = false;
                that.stopApiLoading();
                that.clearSelection();
            }

            let f = function (error) {
                console.log(error)
                that.$bvToast.toast(
                    "Error loading items for the date range.",
                    { title: "Error", autoHideDelay: 1500, variant: "danger" }
                );
                that.items_being_loaded = false;
                that.stopApiLoading();
                that.clearSelection();
            }

            this.items = [];
            this.items_being_loaded = true;
            this.selected_state = null;
            this.pick_location_id = null;
            this.drop_location_id = null;
            this.selected_order_type = null;
            Requestor.postAsync(path, data, s, f);
        },
        
        update_colors_dict: function () {
            for (var i = 0; i < this.items.length; i++) {
                let invoice_id = this.items[i].invoice_id;
                for (var j = 0; j < this.items[i].items.length; j++) {
                    let itemid = this.items[i].items[j].itemid;
                    let state = this.items[i].items[j].state;

                    let color = 'white';
                    if (state == 2) {
                        color = '#c5e1a5'
                    }
                    if (state == -2) {
                        color = '#b0bec5'
                    }

                    let key = invoice_id + itemid;
                    this.colors_dict[key] = color;
                }
            }
        },
        
        fetch_prereqs: function () {
        },
        
        fetch: function () {
            this.items = []
            this.dates = []
            this.active_date = null;
            this.locsub = null;
        },
        
        sortby: function (key, mapper) {
            if (this.sort_asc) {
                this.items = Requestor.sort(this.items, key, mapper)
            }
            else {
                this.items = Requestor.sort_reverse(this.items, key, mapper)
            }
            this.sort_asc = !this.sort_asc;
        },
        
        isMobile: function () {
            if (
                (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
                ||
                screen.width <= 760
            ) {
                return true
            } else {
                return false
            }
        },
        
        filter_locations: function (locations) {
            if (!this.packet || !this.packet.userDetails) {
                return locations || [];
            }

            let userrole = this.packet.userDetails.userrole;
            let userLocationId = undefined;

            if (userrole !== 'admin' && userrole !== 'officeuser' && userrole !== 'housetruck') {
                if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                    userLocationId = this.packet.userDetails.properties.location_id;
                }
            }

            if (userrole == 'admin' || userrole == 'officeuser' || userrole == 'housetruck') {
                return locations ? locations.filter(d => d && ![44, 46].includes(d.value)) : [];
            }
            else {
                if (userLocationId) {
                    return locations ? locations.filter(function (d) {
                        return d && d.value == userLocationId;
                    }) : [];
                } else {
                    return locations ? locations.filter(function (d) {
                        return d && (d.is_main_warehouse === true || d.is_main_warehouse === 1);
                    }) : [];
                }
            }
        },
        
        initDatePicker: function() {
            this.$nextTick(() => {
                try {
                    const Lightpick = require('lightpick');
                    let that = this;
                    
                    var picker = new Lightpick({
                        field: document.getElementById('dates'),
                        singleDate: false,
                        repick: true,
                        format: 'YYYY-MM-DD',
                        onSelect: function(start, end) {
                            that.query.startDate = start ? start.format('YYYY-MM-DD') : '';
                            that.query.endDate = end ? end.format('YYYY-MM-DD') : '';
                            if (start && end) {
                                that.search_dates();
                            }
                        }
                    });
                    
                    picker.setDate(moment().toDate());
                } catch (error) {
                    console.error('Error initializing date picker:', error);
                }
            });
        },
    },
    
    mounted: function() {
        this.initDatePicker();
        this.search_dates();
    },
    
    created: function() {
        try {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.locsubs = this.packet.locsubs || [];
            this.original_locsubs = this.packet.original_locsubs || [];

            let userrole = this.packet.userDetails.userrole;
            if (userrole !== 'admin' && userrole !== 'officeuser' && userrole !== 'housetruck') {
                if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                    let location_id = this.packet.userDetails.properties.location_id;
                    this.locsubs = this.locsubs.filter(function(d) {
                        return d.location_id == location_id;
                    });
                }
            }

            this.states = this.get_allowed_states();
        } catch (error) {
            console.error('Error initializing component:', error);
            this.packet = { userDetails: {}, locsubs: [], locsubsdict: {}, trucksdict: {} };
            this.locsubs = [];
            this.original_locsubs = [];
            this.states = mappings.states.map(function(d){ d.disabled = true; return d; });
        }
    },
    
    beforeDestroy() {
        if (this.loadingInterval) clearInterval(this.loadingInterval);
        if (this.tipInterval) clearInterval(this.tipInterval);
        if (this.msgInterval) clearInterval(this.msgInterval);
    }
}
</script>

<style scoped>
    /* Glass Theme Container */
    .items-to-pull.glass-theme {
        position: relative;
        background: transparent !important;
        min-height: 100vh;
        padding: 24px;
    }

    .items-to-pull.glass-theme::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        filter: blur(10px);
        opacity: 0.5;
        z-index: -2;
        transform: scale(1.1);
    }

    /* Glass Card Effect */
    .glass-alert,
    .glass-table-card,
    .glass-empty-alert {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 20px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    /* Bulk Action Bar - NEW */
    .bulk-action-bar {
        padding: 12px 20px;
        margin-bottom: 15px;
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.95) !important;
        border: 2px solid rgba(66, 153, 225, 0.3) !important;
        box-shadow: 0 2px 12px rgba(66, 153, 225, 0.1) !important;
    }

    .bulk-action-content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 15px;
    }

    .selected-count {
        font-weight: 600;
        color: #2d3748;
        margin-right: 10px;
        font-size: 14px;
    }

    .bulk-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
        flex: 1;
    }

    .bulk-state-select {
        width: 200px !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        border: 2px solid #495057 !important;
        border-radius: 8px !important;
        background: white !important;
        height: 40px !important;
    }

    .apply-bulk-btn {
        height: 40px !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        padding: 0 20px !important;
        background: linear-gradient(135deg, #4299e1, #3182ce) !important;
        border: none !important;
        color: white !important;
        border-radius: 8px !important;
        transition: all 0.3s ease !important;
    }

    .apply-bulk-btn:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(66, 153, 225, 0.3) !important;
    }

    .apply-bulk-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .clear-selection-btn {
        height: 40px !important;
        font-size: 13px !important;
        border: 2px solid #e2e8f0 !important;
        border-radius: 8px !important;
        color: #4a5568 !important;
        background: transparent !important;
        transition: all 0.3s ease !important;
    }

    .clear-selection-btn:hover:not(:disabled) {
        background: #f7fafc !important;
        border-color: #cbd5e0 !important;
    }

    .clear-selection-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    /* Checkbox styles - NEW */
    .select-all-checkbox,
    .item-checkbox {
        transform: scale(1.2);
        margin: 0;
        cursor: pointer;
    }

    .select-all-checkbox:disabled,
    .item-checkbox:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    .select-all-checkbox >>> .custom-control-label::before,
    .item-checkbox >>> .custom-control-label::before {
        border-radius: 4px !important;
    }

    /* Glass Inputs */
    .glass-input {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 2px solid rgba(0, 0, 0, 0.1) !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }

    .glass-input:focus {
        border-color: #4299e1 !important;
        box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1) !important;
    }

    .glass-select {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 2px solid rgba(0, 0, 0, 0.1) !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }

    .glass-select:hover {
        background: rgba(255, 255, 255, 0.95) !important;
        border-color: rgba(0, 0, 0, 0.2) !important;
    }

    /* Glass Button */
    .glass-btn {
        background: linear-gradient(135deg, #4a5568, #2d3748) !important;
        border: none !important;
        color: white !important;
        transition: all 0.3s ease !important;
        border-radius: 12px !important;
    }

    .glass-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    }

    /* Glass Comment Button */
    .glass-comment-btn {
        background: rgba(0, 123, 255, 0.1);
        border: 1px solid rgba(0, 123, 255, 0.3);
        color: #007bff;
        padding: 5px 10px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .glass-comment-btn:hover:not(:disabled) {
        background: rgba(0, 123, 255, 0.2);
        transform: scale(1.05);
    }

    .glass-comment-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    /* Glass Table */
    .glass-table {
        border-collapse: separate;
        border-spacing: 0;
        width: 100%;
    }

    .glass-table-header {
        background: rgba(60, 60, 60, 0.9) !important;
        backdrop-filter: blur(5px);
        padding: 3px !important;
    }

    .glass-table-row {
        transition: all 0.3s ease;
    }

    .glass-table-row:hover {
        background: rgba(255, 255, 255, 0.7) !important;
        transform: scale(1.01);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    /* Glass Status Select */
    .glass-status-select {
        border-radius: 8px !important;
        transition: all 0.3s ease !important;
    }

    .glass-status-select:hover {
        transform: scale(1.02);
    }

    /* Filter Label */
    .filter-label {
        font-weight: bold;
        font-size: 11px;
        margin-bottom: 4px;
        color: #4a5568;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    /* Existing styles */
    select option:disabled {
        color: #888 !important;
        font-style: italic;
        background-color: #f5f5f5 !important;
    }

    select option {
        padding: 8px 12px !important;
        font-size: 13px !important;
    }

    select option:not(:disabled) {
        font-weight: 600;
        background-color: white !important;
    }

    select option[disabled] {
        border-bottom: 1px solid #e0e0e0;
    }

    select option:not(:disabled):hover {
        background-color: #e8f5e9 !important;
    }

    select[size="sm"] {
        min-width: 180px !important;
    }

    .diver {
        overflow: auto;
        width: 100%;
        height: 800px;
    }

    .srr {
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        background: rgb(60, 60, 60);
        color: white;
        border: 1px solid #ffffff;
        padding: 0px;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

    table {
        table-layout: fixed;
        width: 100%;
    }

    .ipt_tdr {
        font-family: roboto !important;
        font-size: 13px;
        background: white;
    }

    .pcol {
        padding: 5px;
    }

    .card-body {
        padding: 5px;
    }

    /* ========== Loading Overlay Styles ========== */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(20px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loading-overlay-enter-active {
        animation: fadeIn 0.3s ease;
    }

    .loading-overlay-leave-active {
        animation: fadeOut 0.3s ease;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
    }

    .loading-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(245, 245, 245, 0.95));
        border-radius: 24px;
        padding: 48px 56px;
        text-align: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: cardPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        max-width: 450px;
        width: 90%;
    }

    @keyframes cardPop {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .loading-animation {
        margin-bottom: 32px;
    }

    .loading-ring {
        position: relative;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border: 4px solid transparent;
        border-radius: 50%;
        animation: ringRotate 1.5s linear infinite;
    }

    .ring:nth-child(1) {
        border-top-color: #4299e1;
        border-left-color: #4299e1;
        animation-duration: 1s;
    }

    .ring:nth-child(2) {
        border-right-color: #48bb78;
        border-bottom-color: #48bb78;
        width: 80%;
        height: 80%;
        top: 10%;
        left: 10%;
        animation-duration: 1.2s;
        animation-direction: reverse;
    }

    .ring:nth-child(3) {
        border-left-color: #ed8936;
        border-bottom-color: #ed8936;
        width: 60%;
        height: 60%;
        top: 20%;
        left: 20%;
        animation-duration: 0.8s;
    }

    @keyframes ringRotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .loading-logo {
        font-size: 32px;
        font-weight: bold;
        animation: logoPulse 1.5s ease-in-out infinite;
        z-index: 1;
    }

    .loading-logo i {
        font-size: 40px;
        background: linear-gradient(135deg, #4299e1, #48bb78);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }

    @keyframes logoPulse {
        0%, 100% { transform: scale(1); opacity: 0.7; }
        50% { transform: scale(1.1); opacity: 1; }
    }

    .loading-text {
        margin-bottom: 24px;
    }

    .loading-text h3 {
        color: #2d3748;
        font-size: 1.3rem;
        margin-bottom: 8px;
        display: inline-block;
    }

    .loading-dots {
        display: inline-flex;
        margin-left: 8px;
    }

    .loading-dots .dot {
        width: 6px;
        height: 6px;
        background: #4299e1;
        border-radius: 50%;
        margin: 0 2px;
        animation: dotBounce 1.4s ease-in-out infinite;
    }

    .loading-dots .dot:nth-child(1) { animation-delay: 0s; }
    .loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes dotBounce {
        0%, 60%, 100% { transform: translateY(0); }
        30% { transform: translateY(-8px); }
    }

    .loading-progress {
        width: 100%;
        height: 4px;
        background: #e2e8f0;
        border-radius: 4px;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1);
        background-size: 200% 100%;
        animation: progressShine 1.5s linear infinite;
        transition: width 0.3s ease;
        border-radius: 4px;
    }

    @keyframes progressShine {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }

    .loading-tips {
        margin-top: 20px;
    }

    .tip-text {
        color: #718096;
        font-size: 0.9rem;
        animation: tipFade 0.5s ease;
    }

    @keyframes tipFade {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Responsive design */
    @media (max-width: 768px) {
        .items-to-pull.glass-theme {
            padding: 16px;
        }
        
        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
        
        .responsive-input {
            width: 100% !important;
            display: block !important;
        }
        
        .loading-card {
            padding: 32px 24px;
        }

        .bulk-action-content {
            flex-direction: column;
            align-items: stretch;
        }

        .bulk-actions {
            flex-direction: column;
            align-items: stretch;
        }

        .bulk-state-select {
            width: 100% !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/ItemsToPick.vue